import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Divider, IconButton, Stack } from '@mui/material';
import { NotificationBell } from 'components/common/notification-bell';
import { useOutreachActivityVisible } from 'hooks/use-outreach-activity-visible';
import { useAuthContext } from 'providers/auth';
import { FC } from 'react';
import { useLocation, useMatch } from 'react-router';
import routes from 'routes';

interface AppBarProps {
  handleDrawerToggle: () => void;
  handleLogout: () => void;
  handleSearchToggle: () => void;
}

export const AppBar: FC<AppBarProps> = ({ handleDrawerToggle, handleSearchToggle }) => {
  const authContext = useAuthContext();
  const location = useLocation();
  const showingChild = location.pathname.includes('/campaigns/');
  // Shared with OutreachActivityProvider so the bell and the feed behind it can't be gated apart.
  const activityVisible = useOutreachActivityVisible();
  // The Companies page renders its own search in its toolbar.
  const onCompaniesPage = !!useMatch(`/${routes.home.companies.path}`);

  return (
    <Stack direction="column" height={128}>
      <Box
        display="flex"
        height={128}
        sx={{
          marginLeft: { sx: 0, md: showingChild ? '88px' : '240px' },
          position: 'relative',
          alignItems: 'center',
          justifyContent: 'space-between',
          zIndex: (theme) => theme.zIndex.drawer - 1,
        }}
      >
        <Stack direction="row" sx={{ alignItems: 'center' }}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ display: { md: 'none' }, marginLeft: 1, marginRight: 1 }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>

          <Box ml={2} id="portal-header-title" />
        </Stack>

        {/* pr is load-bearing: MUI hangs a Badge half its width outside the icon, so flush against
            the viewport edge a two-digit count overflowed the document and grew a scrollbar. */}
        <Stack direction="row" spacing={2} sx={{ pr: 2 }}>
          {activityVisible && <NotificationBell />}
          {authContext.isInternal && !onCompaniesPage && (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="search"
              onClick={handleSearchToggle}
            >
              <SearchIcon />
            </IconButton>
          )}
        </Stack>
      </Box>
      <Divider />
    </Stack>
  );
};
